<template>
  <div class="py-5 container-fluid">
    <div id="topinfo">
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <div class="mx-auto col-xl-8 col-lg-9 col-md-10 d-flex mb-2 flex-column card card-body blur shadow-blur">
            <div class="card-header mb-0 text-center">
              <h3 class="font-weight-bolder text-success text-gradient">coatingAI FineTune</h3>
              <h5 class="mb-0">
                for Line <i>{{ line.name }}</i>
              </h5>
            </div>
          </div>
          <div class="mt-4 mx-auto col-xl-8 col-lg-9 col-md-10 d-flex flex-column card card-body blur shadow-blur">
            <div class="card-header row justify-content-left mt-3">
              <div class="row mt-3 mb-5 text-center">
                <div class="col">
                  <button
                    class="btn mt-2 mb-0 ms-lg-auto me-lg-0 me-auto mt-lg-0"
                    type="button"
                    style="
                      background-color: rgb(241, 241, 241);
                      word-wrap: normal;
                      font-size: min(0.9rem, max(1vw, 0.7rem));
                    "
                    @click="$router.push({name: 'GunsEqualizationFineTune', params: {lineId: lineId}});"
                  >
                    <span
                      style="
                        width: 2.5rem;
                        height: 2.5rem;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <GunSvg
                        :fill-color="'\#66758E'"
                        style="width: 90%; height: 90%; scale: 3"
                      ></GunSvg>
                    </span>
                    <br />
                    Guns Equalization
                  </button>
                </div>
                <div class="col">
                  <button
                    class="btn mt-2 mb-0 ms-lg-auto me-lg-0 me-auto mt-lg-0"
                    type="button"
                    style="
                      background-color: rgb(241, 241, 241);
                      word-wrap: normal;
                      font-size: min(0.9rem, max(1vw, 0.7rem));
                    "
                    @click="$router.push({ name: 'ThicknessAdjustmentFineTune' });"
                  >
                    <span
                      style="
                        width: 2.5rem;
                        height: 2.5rem;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <i
                        class="fa fa-bars fa-3x"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <br />
                    Thickness Adjustment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GunSvg from "@/components/GunSvg.vue";
import setTooltip from "@/assets/js/tooltip.js";

export default {
  name: "FineTuneLineDashboard",
  components: {
    GunSvg,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
  },
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;

    return {
      line: {
        name: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
    this.getData();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
  methods: {
    async getData() {
      await this.getFineTuneLine();
    },
    async getFineTuneLine() {
      try {
        const line_response = await axios.get("api/v1/finetune/line/" + this.lineId + "/");

        line_response.data.pistols_max_movement_range = line_response.data.pistols_max_movement_range * 100;

        this.line = line_response.data;
        this.$store.state.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
